import { AdapterState }     from '@core/interfaces/store.interface';
import { EntityAdapter }    from '@ngrx/entity';
import { createSelector }   from '@ngrx/store';
import { MemoizedSelector } from '@ngrx/store/src/selector';


export interface IAdapterSelectors<T> {
	ids;
	entities;
	all;
	total;
}

export function adapterSelectors<T, S extends AdapterState<T>>(
	adapter: EntityAdapter<T>,
	featureSelector: MemoizedSelector<object, S>
) {
	const {
		selectIds,
		selectEntities,
		selectAll,
		selectTotal
	} = adapter.getSelectors(( storeState: S ) =>
		storeState.adapter
	);


	return {
		ids: createSelector( featureSelector, selectIds),
		entities: createSelector( featureSelector, selectEntities),
		all: createSelector( featureSelector, selectAll),
		total: createSelector( featureSelector, selectTotal),
	};
}
